import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const FreshUpdatesButton = (props) => {
  const {
    freshItemsCount,
    iconSpinning,
    inboxSection,
    navigate,
    initialCallRef,
    setIconSpinning,
    setFreshItemsCount,
    setIntervalRefreshTrigger,
  } = props;

  const handleRefresh = () => {
    setIconSpinning(true);
    setFreshItemsCount(0);
    setIntervalRefreshTrigger((n) => n + 1);

    const source = new AbortController();

    // If the user is using a URL-driven time window (`startDateTime`/`minutesPerCall`),
    // "New updates" should switch back to the normal behavior (relative to now).
    const startDateTimeParam = inboxSection ? getUrlParam('startDateTime') : null;
    const minutesPerCallParam = inboxSection ? getUrlParam('minutesPerCall') : null;

    if (startDateTimeParam || minutesPerCallParam) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('startDateTime');
      urlParams.delete('minutesPerCall');
      const newSearch = urlParams.toString();
      navigate({ search: newSearch ? `?${newSearch}` : '' }, { replace: true });

      // Ensure `window.location.search` has been updated before creating results.
      setTimeout(() => initialCallRef.current(source, { forceSetMarker: true }), 0);
    } else {
      initialCallRef.current(source, { forceSetMarker: true });
    }

    setTimeout(() => setIconSpinning(false), 300);
  };

  return (
    <button
      className={`fresh-items-button general-button action-button rounded-button alerts-button z-max ${
        freshItemsCount > 0 || iconSpinning ? '' : 'fresh-items-button-hidden'
      }`}
      onClick={handleRefresh}
    >
      <span className={`icon-refresh mr-2 ${iconSpinning ? 'icon-refresh-spin' : ''}`}></span>
      New updates {freshItemsCount > 0 && `(${freshItemsCount})`}
    </button>
  );
};

export default FreshUpdatesButton;

